import { gql } from 'apollo-angular';

export const BlockedSeatFragment = gql`
  fragment BlockedSeat on BlockedSeatOutput {
    id
    seatId
  }
`;
